import React from 'react';

import fetch from './../fetch';

export default {
    entryURL:'/listenManager/entryPage',
}